<template>
  <input :type="inputType" @input="setValue($event.target.value)" :value="getValue"
         :maxlength="property.maxLength"
         :pattern="property.pattern"
         :placeholder="placeholder"
         :readonly="property.readOnly"
         :min="property.minimum"
         :max="property.maximum"
  >
</template>

<script>
    import singleControlMixin from './singleControlMixin'
    export default {
      name: "input-control",
      mixins: [singleControlMixin],
      computed:{
        inputType(){
          const p = this.property;
          switch(p.type){
            case 'string': if(p.format=="date-time") return 'datetime-local';
            else if(p.format=="time") return 'time';
            else return 'text';
            case 'integer': if(p.format=="date-time") return 'datetime-local';
            else if(p.format=="time") return 'time';
            else return 'number';
            case 'number': return 'number';

          }
          throw "Unsupport type,format property"
        },
      },

    }
</script>

<style scoped>

</style>
